<template>
    <div
        :data-component="$options.name"
        class="w-full mb-80"
    >
        <div
            class="flex flex-col items-center m-auto w-full screen-m:w-[534px] screen-l:w-[607px] screen-xxl:w-[720px]"
        >
            <unavailable-svg class="mb-16 w-[280px]"></unavailable-svg>
            <ms-headline
                type="h3"
                class="mb-8 text-center"
                :isSpan="true"
                >{{ content.headline }}</ms-headline
            >
            <p class="mb-24 text-center">
                {{ content.paragraph }}
            </p>
            <cs-primary-button :href="resultListUrl">Immobilie finden</cs-primary-button>
        </div>
    </div>
</template>
<script lang="ts" src="./MsDetailUnavailable.ts" />
